export const statusSupplyOrderText = {
    new: 'Нова',
    work: 'В роботі',
    approval: 'На узгодженні',
    processed: 'Оброблено',
    delivered: 'Доставлено',
    // cancel: 'Відхилено',
    cancel: 'Скасовано',
    success: 'Успішно',
}

export const statusSupplyBillPaymentText = {
    prepayment: 'Передсплата',
    postpaid: 'Післяплата',
}

export const statusDeliverText = {
    created: 'Створено',
    deliver: 'Доставляється',
    delivered: 'Доставлено',
}

export const statusPaymentText = {
    '': 'Створено',
    payWait: 'Передано на оплату',
    scheduledPayment: 'Заплановано на оплату',
    pay: 'Сплачено',
}